import { render, staticRenderFns } from "./Short_form_JumpAttribute.vue?vue&type=template&id=42bc51c1&scoped=true&"
import script from "./Short_form_JumpAttribute.vue?vue&type=script&lang=js&"
export * from "./Short_form_JumpAttribute.vue?vue&type=script&lang=js&"
import style0 from "./Short_form_JumpAttribute.vue?vue&type=style&index=0&id=42bc51c1&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bc51c1",
  null
  
)

export default component.exports